<template>
  <div
    v-click-outside="onClickOutside"
    :class="`regions-dropdown-select ${ hideTop ? 'regions-dropdown-select--top-hidden' : '' }`"
    :style="`${ minWidth !== null ? `min-width: ${minWidth}px;` : ''};`"
  >
    <base-dropdown
      v-if="!hideTop"
      :label="displayText"
      :active="isOpen"
      @click="toggleDropdown"
    />
    <transition name="fade">
      <div
        v-if="isOpen"
        class="regions-dropdown-select__popover"
      >
        <div
          v-for="(item, index) in items"
          :key="`regions-dropdown-select-${index}`"
          class="regions-dropdown-select__popover__item"
          :style="`${value === index ? 'background-color: #F0F0F0;' : '' } `"
          @click="handleSelect(index)"
        >
          <base-text
            style="align-self: center;"
            size="md"
          >
            {{ item }}
          </base-text>
          <div class="regions-dropdown-select__popover__icon">
            <base-icon v-if="value === index" icon="check" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'RegionsDropdownSelect',
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: Number,
      default: null,
    },
    forceOpen: {
      type: Boolean,
      default: false,
    },
    hideTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    displayText() {
      return this.items.find((value, index) => index === this.value) ?? this.label;
    },
  },
  mounted() {
    if (this.forceOpen) {
      this.isOpen = true;
    }
  },
  methods: {
    handleSelect(index) {
      this.$emit('input', index);
      if (this.hideTop && this.forceOpen) {
        return;
      }
      this.isOpen = false;
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    onClickOutside() {
      if (this.isOpen && !this.persistent) this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.regions-dropdown-select {
  position: relative;
  border: solid thin #CCC;
  border-radius: 4px;
  padding: 10px;
  min-width: 320px;

  &--top-hidden {
    border: none;
    padding: 0;
    top: -20px;
  }

  .base-dropdown {
    display: flex;
  }

  &__popover {
    margin-top: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    background-color: white;
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 0;
    display: flex;
    flex-direction: column;
    &__item {
      justify-content: space-between;
      display: flex;
      cursor: pointer;
      align-content: center;
      width: 100%;
      height: 35px;
      padding: 0px 10px 0px 10px;
    }
    &__item:hover{
        background-color: #F0F0F0;
      }

    &__icon {
      width: 15px;
      height: 15px;
      display: flex;
      align-self: center;
      padding: 1x 9px 3px 0;
    }
  }
}
</style>
